import { UserSubRoles, userSubRolesToLabelMap } from '@bb/users';
import React from 'react';
import { Tag } from 'components';
import styled from 'styled-components';

type RoleTagProps = {
  subRole: UserSubRoles;
};

const subRoleColorMap: Record<UserSubRoles, string> = Object.values(
  UserSubRoles,
).reduce(
  (acc, subRole) => ({ ...acc, [subRole]: 'blue' }),
  {} as Record<UserSubRoles, string>,
);

const RoleTag: React.FC<RoleTagProps> = ({ subRole }) => {
  if (!subRole) return null;

  const label = userSubRolesToLabelMap[subRole];
  const color = subRoleColorMap[subRole];

  if (!label || !color) return null;

  return <StyledTag color={color}>{label}</StyledTag>;
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default RoleTag;
